/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  mobileNumber: null,
  codeExpiry: null,
  canResendLoginCode: true,
  message: null,
  loginCodeSendingFailed: false,
  validationResult: {
    isValidated: false,
    isMobileConfirmed: false,
    failureCount: 0,
  },
};

const reducer = handleActions(
  {
    [actionTypes.LOGIN_CODE_SENT]: (state, { payload }) => ({
      ...state,
      mobileNumber: payload.mobile,
      codeExpiry: payload.codeExpiry,
    }),
    [actionTypes.UPDATE_LOGIN_CODE_SENDING_FAILURE]: (state, { payload }) => ({
      ...state,
      mobileNumber: null,
      loginCodeSendingFailed: payload.loginCodeSendingFailed,
      message: payload.message,
      canResendLoginCode: payload.canResendLoginCode,
    }),
    [actionTypes.UPDATE_MOBILE_VALIDATION_RESULT]: (state, { payload }) => ({
      ...state,
      validationResult: {
        isValidated: payload.isValidated,
        isMobileConfirmed: payload.isMobileConfirmed,
        failureCount: payload.failureCount,
      },
      message: payload.message,
    }),
    [actionTypes.RESET_VALIDATION]: (state) => {
      const validationResult = Object.assign({}, state.validationResult);
      validationResult.isValidated = false;
      validationResult.isMobileConfirmed = false;

      return {
        ...state,
        validationResult,
        message: null,
      };
    },
    [actionTypes.UPDATE_CAN_RESEND_LOGIN_CODE]: (state, { payload }) => ({
      ...state,
      canResendLoginCode: payload,
    }),
    [actionTypes.RESET]: () => ({
      ...initialState,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
